/**
 * 수동 트래킹 컴포넌트
 * 사용법: <v-track :title="post.title"/>
 */
export default {
    name: 'VTrack',
    abstract: true,
    props: {
        title: String
    },
    methods: {
        track() {
            this.$ga.page({
                page: '/gyeongridan' + this.$route.path,
                title: this.title,
                location: window.location.href
            })
        }
    },
    watch: {
        $route() {
            this.track()
        }
    },
    mounted() {
        if (process.browser) {
            this.track()
        }
    },
    render: () => ''
}